import { useLazyGetDownloadBlankQuery } from "store/api";
import { memo, useMemo } from "react";
import { Person } from "../blank-table";
import { ArrowDownToLine } from "@gravity-ui/icons";
import { EXPORT_PDF } from "features/blank/constants";
import { Button, Icon } from "@gravity-ui/uikit";
import Box from '@mui/material/Box';
import type { MRT_RowSelectionState } from 'material-react-table';
import styles from "../styles.module.scss";

interface BoxProps {
	data: Person[];
	rowSelection: MRT_RowSelectionState;
}

const BoxComponent = ({ data, rowSelection }: BoxProps) => {
    const [downloadSelectedBlanks] = useLazyGetDownloadBlankQuery();

    const selectedRows = useMemo(() => {
        return data.filter((_, index) => rowSelection[index.toString()]);
    }, [data, rowSelection]);

    const selectedCount = Object.keys(rowSelection).length;

    // Не показываем компонент если ничего не выбрано
    if (selectedCount === 0) {
        return null;
    }

    const handleDownloadMultiple = async () => {
        const ids = selectedRows.map((row) => row.id).filter((id): id is number => typeof id === 'number');

        if (!ids.length) {
            console.log('Нет выбранных бланков для скачивания');
            return;
        }

        try {
            const blob = await downloadSelectedBlanks(ids).unwrap();
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `blanks_${ids.join('_')}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Ошибка при скачивании бланков:', error);
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '20px',
                borderRadius: '10px',
                height: '60px',
                p: '0 20px',
                backgroundColor: '#ff5100',
            }}
        >
            <Box
                sx={{
                    alignItems: 'center',
                    display: 'flex',
                    gap: '16px',
                    width: '100%',
                    color: 'white',
                    fontWeight: '600',
                }}
            >
                <span>Бланков: {selectedCount}</span>
                <Button
                    className={styles.blankTable__alret_btn}
                    view="normal-contrast"
                    size="l"
                    onClick={handleDownloadMultiple}
                >
                    <Icon data={ArrowDownToLine} size={16} />
                    {EXPORT_PDF}
                </Button>
            </Box>
        </Box>
    );
};

export default memo(BoxComponent);